<h1 class="mb-4 syne-text fw-semibold fs-32">
    {{'my_subscription' | translate}}
</h1>
<div class="row">
    <div class="col-12">
        <div class="card p-4 rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-start px-3 mb-3">
                <div>
                    <div class="syne-text fs-25 fw-semibold">
                        {{'your_subscription' | translate}}
                    </div>
                    <div class="text-muted fs-16">
                        {{'view_subscription_details' | translate}}
                    </div>
                </div>
                <button class="btn compare-btn rounded-pill px-4 p-2 fs-16" (click)="scrollToPlans.emit()">
                    {{'compare_plans' | translate}}
                </button>
            </div>

            <div class="row px-3" *ngIf="currentPlan">
                <div class="col-12 col-md-3 p-1">
                    <div class="border rounded-4 bdr-black p-2 text-center h-100 d-flex flex-column">
                        <div class="fw-bold syne-text fs-32 text-nowrap">
                            {{ currentPlan.PlanName }}
                        </div>
                        <div class="fw-medium fs-20 mb-3">
                            {{ currentPlan.PriceLabel }}
                        </div>
                        <ul class="list-unstyled text-start ms-2">
                            <li *ngFor="let f of getCardFeatures(currentPlan)"
                                class="d-flex align-items-start fs-16 mb-2">
                                <i class="icon skf-yes me-2 flex-shrink-0"></i>
                                <span *ngIf="f.key !== 'insight-special'" class="text-start">
                                    {{ f.key | translate:f }}
                                </span>
                                <span *ngIf="f.key === 'insight-special'" class="text-start">
                                    {{ 'cardInsightMain' | translate }}<br>
                                    {{ f.extra | translate }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- 
<div class="row mt-3">
    <div class="col-12">
        <div class="card p-4 rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-start px-3 mb-3">
                <div>
                    <div class="syne-text fs-25 fw-semibold">
                        {{'upgrade_subscription' | translate }}
                    </div>

                    <div class="text-muted fs-16">
                        {{ 'discover_other_plans' | translate}}
                    </div>
                </div>

                <button class="btn compare-btn rounded-pill px-4 p-2 fs-16" (click)="scrollToPlans.emit()">
                    {{'compare_plans' | translate}}
                </button>
            </div>

            <div class="row px-3" *ngIf="upgradePlans">
                <div class="col-12 col-md-3 p-1" *ngFor="let plan of upgradePlans">
                    <div class="border rounded-4 bdr-black p-2 text-center h-100 d-flex flex-column">
                        <div class="fw-bold syne-text fs-32">
                            {{ plan.PlanName }}
                        </div>
                        <div class="fw-medium fs-20 mb-3">
                            {{ plan.PriceLabel }}
                        </div>
                        <ul class="list-unstyled flex-grow-1 ps-1">
                            <li *ngFor="let f of getCardFeatures(plan)" class="d-flex align-items-start fs-16 mb-2">
                                <i class="icon skf-yes me-2 mt-1 flex-shrink-0"></i>
                                <span *ngIf="f.key !== 'insight-special'" class="text-start">
                                    {{ f.key | translate:f }}
                                </span>
                                <span *ngIf="f.key === 'insight-special'" class="text-start">
                                    {{ 'cardInsightMain' | translate }}<br>
                                    {{ f.extra | translate }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->